/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

/* eslint-disable @typescript-eslint/naming-convention */
export const countryList = [
  { label: "Afghanistan", value: "AFG", "country-code": "004" },
  { label: "Åland Islands", value: "ALA", "country-code": "248" },
  { label: "Albania", value: "ALB", "country-code": "008" },
  { label: "Algeria", value: "DZA", "country-code": "012" },
  { label: "American Samoa", value: "ASM", "country-code": "016" },
  { label: "Andorra", value: "AND", "country-code": "020" },
  { label: "Angola", value: "AGO", "country-code": "024" },
  { label: "Anguilla", value: "AIA", "country-code": "660" },
  { label: "Antarctica", value: "ATA", "country-code": "010" },
  { label: "Antigua and Barbuda", value: "ATG", "country-code": "028" },
  { label: "Argentina", value: "ARG", "country-code": "032" },
  { label: "Armenia", value: "ARM", "country-code": "051" },
  { label: "Aruba", value: "ABW", "country-code": "533" },
  { label: "Australia", value: "AUS", "country-code": "036" },
  { label: "Austria", value: "AUT", "country-code": "040" },
  { label: "Azerbaijan", value: "AZE", "country-code": "031" },
  { label: "Bahamas", value: "BHS", "country-code": "044" },
  { label: "Bahrain", value: "BHR", "country-code": "048" },
  { label: "Bangladesh", value: "BGD", "country-code": "050" },
  { label: "Barbados", value: "BRB", "country-code": "052" },
  { label: "Belarus", value: "BLR", "country-code": "112" },
  { label: "Belgium", value: "BEL", "country-code": "056" },
  { label: "Belize", value: "BLZ", "country-code": "084" },
  { label: "Benin", value: "BEN", "country-code": "204" },
  { label: "Bermuda", value: "BMU", "country-code": "060" },
  { label: "Bhutan", value: "BTN", "country-code": "064" },
  {
    label: "Bolivia (Plurinational State of)",
    value: "BOL",
    "country-code": "068",
  },
  {
    label: "Bonaire, Sint Eustatius and Saba",
    value: "BES",
    "country-code": "535",
  },
  { label: "Bosnia and Herzegovina", value: "BIH", "country-code": "070" },
  { label: "Botswana", value: "BWA", "country-code": "072" },
  { label: "Bouvet Island", value: "BVT", "country-code": "074" },
  { label: "Brazil", value: "BRA", "country-code": "076" },
  {
    label: "British Indian Ocean Territory",
    value: "IOT",
    "country-code": "086",
  },
  { label: "Brunei Darussalam", value: "BRN", "country-code": "096" },
  { label: "Bulgaria", value: "BGR", "country-code": "100" },
  { label: "Burkina Faso", value: "BFA", "country-code": "854" },
  { label: "Burundi", value: "BDI", "country-code": "108" },
  { label: "Cabo Verde", value: "CPV", "country-code": "132" },
  { label: "Cambodia", value: "KHM", "country-code": "116" },
  { label: "Cameroon", value: "CMR", "country-code": "120" },
  { label: "Canada", value: "CAN", "country-code": "124" },
  { label: "Cayman Islands", value: "CYM", "country-code": "136" },
  {
    label: "Central African Republic",
    value: "CAF",
    "country-code": "140",
  },
  { label: "Chad", value: "TCD", "country-code": "148" },
  { label: "Chile", value: "CHL", "country-code": "152" },
  { label: "China", value: "CHN", "country-code": "156" },
  { label: "Christmas Island", value: "CXR", "country-code": "162" },
  {
    label: "Cocos (Keeling) Islands",
    value: "CCK",
    "country-code": "166",
  },
  { label: "Colombia", value: "COL", "country-code": "170" },
  { label: "Comoros", value: "COM", "country-code": "174" },
  { label: "Congo", value: "COG", "country-code": "178" },
  {
    label: "Congo, Democratic Republic of the",
    value: "COD",
    "country-code": "180",
  },
  { label: "Cook Islands", value: "COK", "country-code": "184" },
  { label: "Costa Rica", value: "CRI", "country-code": "188" },
  { label: "Côte d'Ivoire", value: "CIV", "country-code": "384" },
  { label: "Croatia", value: "HRV", "country-code": "191" },
  { label: "Cuba", value: "CUB", "country-code": "192" },
  { label: "Curaçao", value: "CUW", "country-code": "531" },
  { label: "Cyprus", value: "CYP", "country-code": "196" },
  { label: "Czechia", value: "CZE", "country-code": "203" },
  { label: "Denmark", value: "DNK", "country-code": "208" },
  { label: "Djibouti", value: "DJI", "country-code": "262" },
  { label: "Dominica", value: "DMA", "country-code": "212" },
  { label: "Dominican Republic", value: "DOM", "country-code": "214" },
  { label: "Ecuador", value: "ECU", "country-code": "218" },
  { label: "Egypt", value: "EGY", "country-code": "818" },
  { label: "El Salvador", value: "SLV", "country-code": "222" },
  { label: "Equatorial Guinea", value: "GNQ", "country-code": "226" },
  { label: "Eritrea", value: "ERI", "country-code": "232" },
  { label: "Estonia", value: "EST", "country-code": "233" },
  { label: "Eswatini", value: "SWZ", "country-code": "748" },
  { label: "Ethiopia", value: "ETH", "country-code": "231" },
  {
    label: "Falkland Islands (Malvinas)",
    value: "FLK",
    "country-code": "238",
  },
  { label: "Faroe Islands", value: "FRO", "country-code": "234" },
  { label: "Fiji", value: "FJI", "country-code": "242" },
  { label: "Finland", value: "FIN", "country-code": "246" },
  { label: "France", value: "FRA", "country-code": "250" },
  { label: "French Guiana", value: "GUF", "country-code": "254" },
  { label: "French Polynesia", value: "PYF", "country-code": "258" },
  {
    label: "French Southern Territories",
    value: "ATF",
    "country-code": "260",
  },
  { label: "Gabon", value: "GAB", "country-code": "266" },
  { label: "Gambia", value: "GMB", "country-code": "270" },
  { label: "Georgia", value: "GEO", "country-code": "268" },
  { label: "Germany", value: "DEU", "country-code": "276" },
  { label: "Ghana", value: "GHA", "country-code": "288" },
  { label: "Gibraltar", value: "GIB", "country-code": "292" },
  { label: "Greece", value: "GRC", "country-code": "300" },
  { label: "Greenland", value: "GRL", "country-code": "304" },
  { label: "Grenada", value: "GRD", "country-code": "308" },
  { label: "Guadeloupe", value: "GLP", "country-code": "312" },
  { label: "Guam", value: "GUM", "country-code": "316" },
  { label: "Guatemala", value: "GTM", "country-code": "320" },
  { label: "Guernsey", value: "GGY", "country-code": "831" },
  { label: "Guinea", value: "GIN", "country-code": "324" },
  { label: "Guinea-Bissau", value: "GNB", "country-code": "624" },
  { label: "Guyana", value: "GUY", "country-code": "328" },
  { label: "Haiti", value: "HTI", "country-code": "332" },
  {
    label: "Heard Island and McDonald Islands",
    value: "HMD",
    "country-code": "334",
  },
  { label: "Holy See", value: "VAT", "country-code": "336" },
  { label: "Honduras", value: "HND", "country-code": "340" },
  { label: "Hong Kong", value: "HKG", "country-code": "344" },
  { label: "Hungary", value: "HUN", "country-code": "348" },
  { label: "Iceland", value: "ISL", "country-code": "352" },
  { label: "India", value: "IND", "country-code": "356" },
  { label: "Indonesia", value: "IDN", "country-code": "360" },
  {
    label: "Iran (Islamic Republic of)",
    value: "IRN",
    "country-code": "364",
  },
  { label: "Iraq", value: "IRQ", "country-code": "368" },
  { label: "Ireland", value: "IRL", "country-code": "372" },
  { label: "Isle of Man", value: "IMN", "country-code": "833" },
  { label: "Israel", value: "ISR", "country-code": "376" },
  { label: "Italy", value: "ITA", "country-code": "380" },
  { label: "Jamaica", value: "JAM", "country-code": "388" },
  { label: "Japan", value: "JPN", "country-code": "392" },
  { label: "Jersey", value: "JEY", "country-code": "832" },
  { label: "Jordan", value: "JOR", "country-code": "400" },
  { label: "Kazakhstan", value: "KAZ", "country-code": "398" },
  { label: "Kenya", value: "KEN", "country-code": "404" },
  { label: "Kiribati", value: "KIR", "country-code": "296" },
  {
    label: "Korea (Democratic People's Republic of)",
    value: "PRK",
    "country-code": "408",
  },
  { label: "Korea, Republic of", value: "KOR", "country-code": "410" },
  { label: "Kuwait", value: "KWT", "country-code": "414" },
  { label: "Kyrgyzstan", value: "KGZ", "country-code": "417" },
  {
    label: "Lao People's Democratic Republic",
    value: "LAO",
    "country-code": "418",
  },
  { label: "Latvia", value: "LVA", "country-code": "428" },
  { label: "Lebanon", value: "LBN", "country-code": "422" },
  { label: "Lesotho", value: "LSO", "country-code": "426" },
  { label: "Liberia", value: "LBR", "country-code": "430" },
  { label: "Libya", value: "LBY", "country-code": "434" },
  { label: "Liechtenstein", value: "LIE", "country-code": "438" },
  { label: "Lithuania", value: "LTU", "country-code": "440" },
  { label: "Luxembourg", value: "LUX", "country-code": "442" },
  { label: "Macao", value: "MAC", "country-code": "446" },
  { label: "Madagascar", value: "MDG", "country-code": "450" },
  { label: "Malawi", value: "MWI", "country-code": "454" },
  { label: "Malaysia", value: "MYS", "country-code": "458" },
  { label: "Maldives", value: "MDV", "country-code": "462" },
  { label: "Mali", value: "MLI", "country-code": "466" },
  { label: "Malta", value: "MLT", "country-code": "470" },
  { label: "Marshall Islands", value: "MHL", "country-code": "584" },
  { label: "Martinique", value: "MTQ", "country-code": "474" },
  { label: "Mauritania", value: "MRT", "country-code": "478" },
  { label: "Mauritius", value: "MUS", "country-code": "480" },
  { label: "Mayotte", value: "MYT", "country-code": "175" },
  { label: "Mexico", value: "MEX", "country-code": "484" },
  {
    label: "Micronesia (Federated States of)",
    value: "FSM",
    "country-code": "583",
  },
  { label: "Moldova, Republic of", value: "MDA", "country-code": "498" },
  { label: "Monaco", value: "MCO", "country-code": "492" },
  { label: "Mongolia", value: "MNG", "country-code": "496" },
  { label: "Montenegro", value: "MNE", "country-code": "499" },
  { label: "Montserrat", value: "MSR", "country-code": "500" },
  { label: "Morocco", value: "MAR", "country-code": "504" },
  { label: "Mozambique", value: "MOZ", "country-code": "508" },
  { label: "Myanmar", value: "MMR", "country-code": "104" },
  { label: "Namibia", value: "NAM", "country-code": "516" },
  { label: "Nauru", value: "NRU", "country-code": "520" },
  { label: "Nepal", value: "NPL", "country-code": "524" },
  { label: "Netherlands", value: "NLD", "country-code": "528" },
  { label: "New Caledonia", value: "NCL", "country-code": "540" },
  { label: "New Zealand", value: "NZL", "country-code": "554" },
  { label: "Nicaragua", value: "NIC", "country-code": "558" },
  { label: "Niger", value: "NER", "country-code": "562" },
  { label: "Nigeria", value: "NGA", "country-code": "566" },
  { label: "Niue", value: "NIU", "country-code": "570" },
  { label: "Norfolk Island", value: "NFK", "country-code": "574" },
  { label: "North Macedonia", value: "MKD", "country-code": "807" },
  {
    label: "Northern Mariana Islands",
    value: "MNP",
    "country-code": "580",
  },
  { label: "Norway", value: "NOR", "country-code": "578" },
  { label: "Oman", value: "OMN", "country-code": "512" },
  { label: "Pakistan", value: "PAK", "country-code": "586" },
  { label: "Palau", value: "PLW", "country-code": "585" },
  { label: "Palestine, State of", value: "PSE", "country-code": "275" },
  { label: "Panama", value: "PAN", "country-code": "591" },
  { label: "Papua New Guinea", value: "PNG", "country-code": "598" },
  { label: "Paraguay", value: "PRY", "country-code": "600" },
  { label: "Peru", value: "PER", "country-code": "604" },
  { label: "Philippines", value: "PHL", "country-code": "608" },
  { label: "Pitcairn", value: "PCN", "country-code": "612" },
  { label: "Poland", value: "POL", "country-code": "616" },
  { label: "Portugal", value: "PRT", "country-code": "620" },
  { label: "Puerto Rico", value: "PRI", "country-code": "630" },
  { label: "Qatar", value: "QAT", "country-code": "634" },
  { label: "Réunion", value: "REU", "country-code": "638" },
  { label: "Romania", value: "ROU", "country-code": "642" },
  { label: "Russian Federation", value: "RUS", "country-code": "643" },
  { label: "Rwanda", value: "RWA", "country-code": "646" },
  { label: "Saint Barthélemy", value: "BLM", "country-code": "652" },
  {
    label: "Saint Helena, Ascension and Tristan da Cunha",
    value: "SHN",
    "country-code": "654",
  },
  { label: "Saint Kitts and Nevis", value: "KNA", "country-code": "659" },
  { label: "Saint Lucia", value: "LCA", "country-code": "662" },
  {
    label: "Saint Martin (French part)",
    value: "MAF",
    "country-code": "663",
  },
  {
    label: "Saint Pierre and Miquelon",
    value: "SPM",
    "country-code": "666",
  },
  {
    label: "Saint Vincent and the Grenadines",
    value: "VCT",
    "country-code": "670",
  },
  { label: "Samoa", value: "WSM", "country-code": "882" },
  { label: "San Marino", value: "SMR", "country-code": "674" },
  { label: "Sao Tome and Principe", value: "STP", "country-code": "678" },
  { label: "Saudi Arabia", value: "SAU", "country-code": "682" },
  { label: "Senegal", value: "SEN", "country-code": "686" },
  { label: "Serbia", value: "SRB", "country-code": "688" },
  { label: "Seychelles", value: "SYC", "country-code": "690" },
  { label: "Sierra Leone", value: "SLE", "country-code": "694" },
  { label: "Singapore", value: "SGP", "country-code": "702" },
  {
    label: "Sint Maarten (Dutch part)",
    value: "SXM",
    "country-code": "534",
  },
  { label: "Slovakia", value: "SVK", "country-code": "703" },
  { label: "Slovenia", value: "SVN", "country-code": "705" },
  { label: "Solomon Islands", value: "SLB", "country-code": "090" },
  { label: "Somalia", value: "SOM", "country-code": "706" },
  { label: "South Africa", value: "ZAF", "country-code": "710" },
  {
    label: "South Georgia and the South Sandwich Islands",
    value: "SGS",
    "country-code": "239",
  },
  { label: "South Sudan", value: "SSD", "country-code": "728" },
  { label: "Spain", value: "ESP", "country-code": "724" },
  { label: "Sri Lanka", value: "LKA", "country-code": "144" },
  { label: "Sudan", value: "SDN", "country-code": "729" },
  { label: "Surilabel", value: "SUR", "country-code": "740" },
  { label: "Svalbard and Jan Mayen", value: "SJM", "country-code": "744" },
  { label: "Sweden", value: "SWE", "country-code": "752" },
  { label: "Switzerland", value: "CHE", "country-code": "756" },
  { label: "Syrian Arab Republic", value: "SYR", "country-code": "760" },
  {
    label: "Taiwan, Province of China",
    value: "TWN",
    "country-code": "158",
  },
  { label: "Tajikistan", value: "TJK", "country-code": "762" },
  {
    label: "Tanzania, United Republic of",
    value: "TZA",
    "country-code": "834",
  },
  { label: "Thailand", value: "THA", "country-code": "764" },
  { label: "Timor-Leste", value: "TLS", "country-code": "626" },
  { label: "Togo", value: "TGO", "country-code": "768" },
  { label: "Tokelau", value: "TKL", "country-code": "772" },
  { label: "Tonga", value: "TON", "country-code": "776" },
  { label: "Trinidad and Tobago", value: "TTO", "country-code": "780" },
  { label: "Tunisia", value: "TUN", "country-code": "788" },
  { label: "Turkey", value: "TUR", "country-code": "792" },
  { label: "Turkmenistan", value: "TKM", "country-code": "795" },
  {
    label: "Turks and Caicos Islands",
    value: "TCA",
    "country-code": "796",
  },
  { label: "Tuvalu", value: "TUV", "country-code": "798" },
  { label: "Uganda", value: "UGA", "country-code": "800" },
  { label: "Ukraine", value: "UKR", "country-code": "804" },
  { label: "United Arab Emirates", value: "ARE", "country-code": "784" },
  {
    label: "United Kingdom of Great Britain and Northern Ireland",
    value: "GBR",
    "country-code": "826",
  },
  {
    label: "United States of America",
    value: "USA",
    "country-code": "840",
  },
  {
    label: "United States Minor Outlying Islands",
    value: "UMI",
    "country-code": "581",
  },
  { label: "Uruguay", value: "URY", "country-code": "858" },
  { label: "Uzbekistan", value: "UZB", "country-code": "860" },
  { label: "Vanuatu", value: "VUT", "country-code": "548" },
  {
    label: "Venezuela (Bolivarian Republic of)",
    value: "VEN",
    "country-code": "862",
  },
  { label: "Viet Nam", value: "VNM", "country-code": "704" },
  {
    label: "Virgin Islands (British)",
    value: "VGB",
    "country-code": "092",
  },
  { label: "Virgin Islands (U.S.)", value: "VIR", "country-code": "850" },
  { label: "Wallis and Futuna", value: "WLF", "country-code": "876" },
  { label: "Western Sahara", value: "ESH", "country-code": "732" },
  { label: "Yemen", value: "YEM", "country-code": "887" },
  { label: "Zambia", value: "ZMB", "country-code": "894" },
  { label: "Zimbabwe", value: "ZWE", "country-code": "716" },
];
